
/**
 *      Data-driven UI logic for the search summary controls (TODO: remove, it is no longer used)
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 07/23/2018
 *      Modified on 10/11/2019
 */


/***
 * Returns an integer string with commas separating thousands, e.g. 10000 -> 10,000
 * @param x {number|string} - string representation or a number
 */
function numberWithCommas(x) {
    if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return 0;
}
